import CrudCustom from '../../../libs/custom/CrudCustom';


let SandingPPh21TransaksiService = new CrudCustom('/sanding-pph21-transaksis');
export default SandingPPh21TransaksiService;
